import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CommonMap } from 'client/tracking/maps/common';
import { AppraisalMap } from 'client/tracking/maps/appraisal';

const map = {
  update_down_payment: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SUBACTION_DOWN_PAYMENT
  ),
  update_trade_in: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SUBACTION_TRADE_IN
  ),
  update_owed_amount: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SUBACTION_AMOUNT_OWNED
  ),
  update_select_term: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SUBACTION_SELECT_TERM
  ),
  start_pre_qualification: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.SUBACTION_VIEW_FINANCING_APP
  ),
  rate_lookup: TrackingEvent.trackAction(
    TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.SUBACTION_RATE_LOOKUP
  ),
  lookup_next_click(options) {
    return TrackingEvent.trackAction(
      TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
      TrackingConstant.ACTION_FILL_FORM,
      TrackingConstant.SUBACTION_RATE_LOOKUP,
      options
    );
  },
  lookup_rates_status(options) {
    return TrackingEvent.actionProgress(
      TrackingConstant.ACTION_FILL_FORM,
      TrackingConstant.SUBACTION_RATE_LOOKUP_FAILURE,
      options
    );
  },
  another_source_view_content_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SUBACTION_VIEW_ANOTHER_SOURSE,
    { value: 'collapse' }
  ),
  another_source_view_content_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SUBACTION_VIEW_ANOTHER_SOURSE,
    { value: 'expand' }
  ),
  review_disclosure: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SUBACTION_DISCLOSURE_CHECKBOX
  ),
  financing_edit_form: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.SUBACTION_EDIT_FORM
  ),
  financing_modified_review_form: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.SUBACTION_CHANGE_FINANCING_FORM
  ),
  financing_landing_cta: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.SUBACTION_OPEN_FINANCING_APP,
    {
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
    }
  ),
  open_financing_app: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.SUBACTION_OPEN_FINANCING_APP
  ),
  how_accurate_cta: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_SHOW_CONTENT,
    TrackingConstant.INTEREST_CALC_COACHING,
    { action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY }
  ),
  fn_amountFinanced_input: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.EDIT_AMT_FINANCED
  ),
  fn_apr_input: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, TrackingConstant.EDIT_APR),
  fn_term_input: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, TrackingConstant.EDIT_LOAN_TERM),
};

export const TrackingMap = {
  ...CommonMap,
  ...AppraisalMap,
  ...map,
};
